import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/GetHistogramConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var moment = require('moment');
var country, locality, area, profileId;
var dateRange = {}, filters = {}, masterLocationFilter = false;
var _ = require("lodash");

var TopLocationsAction = function () {

}

TopLocationsAction.prototype = {

	addDownloadFilters: function (data) {
		if (data.profileId) {
			profileId = data.profileId;
			delete data.profileId
		}
		filters = data;
		this.loadData();
	},

	addFilters: function (data) {
		filters = data;
		this.loadData();
	},

	addDownloadFilters: function (data) {
		filters = _.cloneDeep(data);
		if (data.profileId) {
			profileId = filters.profileId;
			delete filters.profileId
		}
		this.loadData();
	},
	masterLocation: function () {
		masterLocationFilter = true;
		this.loadData();
	},

	loadData: function () {

		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		var data = {
			profileId: localStorage.getItem('profileId'),
			filters: filters,
			masterLocationFilter: localStorage.getItem('masterLocationFilter'),
		};
		restClient.getTopLocations(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.TOP_LOCATIONS_RESPONSE,
					data: response
				});
			}
		})
	}
}

export default new TopLocationsAction();